// do not extend this class. routes will become relative.
export const AppUrls = {
  SitePages: {
    Hosts: {
      default: '/SitePages/Forensic/Hosts',
      Map: '/SitePages/Forensic/Hosts/Map',
      WindowsEvents: '/SitePages/Forensic/Hosts/WindowsEvents',
      SystemOverview: {
        default: '/SitePages/Forensic/Hosts/SystemOverview',
        InstalledOSUpdates: '/SitePages/Forensic/Hosts/SystemOverview/InstalledOSUpdates',
        MissingOSUpdates: '/SitePages/Forensic/Hosts/SystemOverview/MissingOSUpdates',
        Arp: '/SitePages/Forensic/Hosts/SystemOverview/Arp',
        InstalledSoftware: '/SitePages/Forensic/Hosts/SystemOverview/InstalledSoftware',
        Shares: '/SitePages/Forensic/Hosts/SystemOverview/Shares',
        DeviceControl: '/SitePages/Forensic/Hosts/SystemOverview/DeviceControl'
      }
    },
    Dashboard: {
      OverallAlerts: '/SitePages/Alerts'
    },
    InitializationPage: '/SitePages/Initialization',
    Files: {
      default: '/SitePages/Forensic/Files',
      Monitor: '/SitePages/Forensic/Files/Monitor'
    },
    sFileso: {
      default: '/SitePages/FileO',
      Monitor: '/SitePages/FileO/Monitor'
    },
    Users: {
      default: '/SitePages/Forensic/Users',
      Logins: '/SitePages/Forensic/Users/Logins'
    },
    Network: {
      Domains: '/SitePages/Forensic/Domains',
      Sockets: '/SitePages/Forensic/Sockets'
    },
    Actions: {
      PlayBooks: '/SitePages/Actions/PlayBooks'
    },
    Settings: {
      Default: '/SitePages/Settings',
      Security: {
        SSLPinning: '/SitePages/Settings/Security/SSLPinning'
      },
      UsersAndRoles: '/SitePages/Settings/UsersAndRoles',
      SitesManagement: '/SitePages/Settings/SitesManagement'
    },
    Siem: {
      default: '/SitePages/Forensic/Siem'
    },
    xdr: {
      default: '/SitePages/Forensic/XDR'
    }
  }
};
